import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import topics from "../data/topics.json";

const startDate = new Date("2025-03-03");

const CalendarGrid = ({ className = "" }) => {
  const navigate = useNavigate();
  const [calendarDates, setCalendarDates] = useState([]);

  const onDayClick = useCallback((key) => {
    navigate(`/41-history-4?date=${key}`);
  }, [navigate]);

  const today = new Date();
  const weekDays = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];

  const getDayIndexFromStart = (date) => {
    const diffTime = date.getTime() - startDate.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays >= 0 ? diffDays % topics.length : null;
  };

  const get14DayTopics = () => {
    const result = [];
    for (let i = -7; i <= 6; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);

      const topicIndex = getDayIndexFromStart(date);
      const topic = topicIndex !== null ? topics[topicIndex]?.Topic : "";

      result.push({
        label: weekDays[date.getDay()],
        date: date.getDate(),
        key: date.toISOString().split("T")[0],
        isToday: date.toDateString() === today.toDateString(),
        topic,
      });
    }
    return result;
  };

  useEffect(() => {
    setCalendarDates(get14DayTopics());
  }, []);

  return (
    <main
      className={`w-full h-full bg-light-primary-key-background flex flex-col items-center justify-start pt-6 px-4 pb-[100px] text-sm text-dark-text font-text-regular-lowercase overflow-y-auto ${className}`}
    >
      <div className="w-full max-w-md">
        <h2 className="text-dark-pink font-semibold text-base mb-4 text-center">
          Lịch học 14 ngày quanh hôm nay
        </h2>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3 justify-center">
          {calendarDates.map((day) => (
            <div
              key={day.key}
              onClick={() => onDayClick(day.key)}
              className={`w-full min-w-[72px] h-24 flex flex-col items-center justify-center rounded-xl cursor-pointer p-2 text-center transition-all duration-150 ${
                day.isToday
                  ? "bg-dark-pink text-white"
                  : "border border-light-text text-dark-text"
              }`}
            >
              <div className="text-xs font-medium">{day.label}</div>
              <div className="text-sm font-semibold">{day.date}</div>
              {day.topic && (
                <div className="text-[10px] mt-1 leading-tight break-words text-dark-pink max-w-[90%] line-clamp-2">
                  {day.topic}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

CalendarGrid.propTypes = {
  className: PropTypes.string,
};

export default CalendarGrid;